<template>
  <div class="header-card-modal-root">
    <transition name="modal-fade">
      <div
        v-if="addNewDataLocal"
        class="modern-modal__overlay"
        @click.self="closeForm">
        <div class="modern-modal modern-modal--xl">
          <loading
            :active.sync="localLoading"
            :can-cancel="true"
            :is-full-page="isFullscreen"></loading>
          <header class="modern-modal__header">
            <div class="modern-modal__header-text">
              <h3 class="modern-modal__title">{{ title }}</h3>
              <p v-if="modalSubtitle" class="modern-modal__subtitle">
                {{ modalSubtitle }}
              </p>
            </div>
            <button class="modern-modal__close" type="button" @click="closeForm">
              <feather-icon icon="XIcon" svgClasses="h-5 w-5" />
            </button>
          </header>
          <section class="modern-modal__body">
            <div class="modern-modal__scroll">
              <vs-table
                ref="table"
                @selected="handleSelected"
                :max-items="itemsPerPage"
                :data="data"
                class="modern-modal__table">
                <div slot="header" class="modern-modal__table-toolbar">
                  <div class="modern-modal__filters">
                    <div class="vs-component vs-con-input-label vs-input mr-2 vs-input-primary">
                      <v-select
                        placeholder="- Select Filter -"
                        style="background: white"
                        @input="(x) => (selected_filter = x.value)"
                        :clearable="false"
                        :value="getSelectValue(selected_filter, filter_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :options="filter_array" />
                    </div>
                    <div
                      v-if="selected_filter != '' && selected_filter != 'all'"
                      class="modern-modal__search-select">
                      <v-select
                        style="
                          left: 0 !important;
                          width: auto !important;
                          height: auto !important;
                          border: 0 !important;
                        "
                        @input="(x) => (search = x.value)"
                        :clearable="false"
                        :value="getSelectValue(search, search_array)"
                        :reduce="(text) => text.value"
                        label="text"
                        :placeholder="
                          `Search ${selected_filter.split('_').join(' ')}`.replace(
                            /(^\w{1})|(\s+\w{1})/g,
                            (letter) => letter.toUpperCase()
                          )
                        "
                        :options="search_array"
                        :filterable="false"
                        @search="onSearch">
                      </v-select>
                    </div>
                    <vs-button
                      v-if="selected_filter != 'all'"
                      type="gradient"
                      :disabled="search == ''"
                      class="shadow-lg modern-modal__filter-btn"
                      color="#d23030"
                      gradient-color-secondary="#f89595"
                      @click="filterData()">
                      <feather-icon
                        svgClasses="h-4 w-4"
                        class="cursor-pointer"
                        icon="SearchIcon"></feather-icon>
                      Filter
                    </vs-button>
                    <vs-button
                      v-if="selected_filter == 'all'"
                      type="gradient"
                      class="shadow-lg modern-modal__filter-btn"
                      color="#d23030"
                      gradient-color-secondary="#f89595"
                      @click="filterData()">
                      <feather-icon
                        svgClasses="h-4 w-4"
                        class="cursor-pointer"
                        icon="SearchIcon"></feather-icon>
                      Filter
                    </vs-button>
                  </div>
                  <div
                    v-if="
                      getRolePermission().dashboard.header_dashboard.enable_download
                    "
                    class="modern-modal__actions">
                    <vs-button
                      type="gradient"
                      class="shadow-lg modern-modal__download-btn"
                      color="#d23030"
                      gradient-color-secondary="#f89595"
                      @click="downloadData()">
                      <feather-icon
                        svgClasses="h-4 w-4"
                        class="cursor-pointer"
                        icon="DownloadIcon"></feather-icon>
                      Download All
                    </vs-button>
                  </div>
                </div>
                <template slot="thead">
        <vs-th
          v-if="getRolePermission().dashboard.header_dashboard.fleet_group"
          >{{ $t('Fleet Group') }}</vs-th
        >
        <vs-th
          v-if="getRolePermission().dashboard.header_dashboard.license_plate"
          >{{ $t('License Plate') }}</vs-th
        >
        <vs-th
          v-if="getRolePermission().dashboard.header_dashboard.vehicle_model"
          >{{ $t('Vehicle Model') }}</vs-th
        >
        <vs-th
          v-if="
            isCommandCenter &&
            getRolePermission().dashboard.header_dashboard.vehicle_number
          "
          >{{ $t('Vehicle Number') }}</vs-th
        >
        <vs-th
          v-if="
            isCommandCenter &&
            getRolePermission().dashboard.header_dashboard.imei
          "
          >{{ $t('IMEI') }}</vs-th
        >
        <vs-th v-if="getRolePermission().dashboard.header_dashboard.driver">{{
          $t('Driver')
        }}</vs-th>
        <vs-th v-if="getRolePermission().dashboard.header_dashboard.driver">{{
          $t('Driver Phone')
        }}</vs-th>
        <vs-th
          v-if="
            type !== 'repair' &&
            getRolePermission().dashboard.header_dashboard.speed
          "
          >{{ $t('Speed') }}</vs-th
        >
        <vs-th
          v-if="getRolePermission().dashboard.header_dashboard.last_update"
          >{{ $t('Last Update') }}</vs-th
        >
        <vs-th v-if="getRolePermission().dashboard.header_dashboard.address">{{
          $t('Address')
        }}</vs-th>
        <vs-th v-if="getRolePermission().dashboard.header_dashboard.duration">{{
          $t('Duration')
        }}</vs-th>
        <vs-th
          v-if="
            (type == 'silent' || type == 'repair') &&
            getRolePermission().dashboard.header_dashboard.action
          "
          >{{ $t('Action') }}</vs-th
        >
      </template>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.fleet_group"
              :data="data[indextr].fleet_group_name">
              <p class="product-name font-medium">{{ tr.fleet_group_name }}</p>
            </vs-td>
            <vs-td
              v-if="
                getRolePermission().dashboard.header_dashboard.license_plate
              "
              :data="data[indextr].license_plate">
              <div class="flex items-center" style="gap: 6px">
                <p class="product-name font-medium mb-0">
                  {{ tr.license_plate }}
                </p>
                <span
                  v-if="isManualVehicle(tr)"
                  class="manual-bookmark"
                  title="Manual Repair">
                  <feather-icon icon="BookmarkIcon" class="w-3 h-3" />
                  <span class="manual-bookmark__text">Manual</span>
                </span>
              </div>
            </vs-td>
            <vs-td
              v-if="
                getRolePermission().dashboard.header_dashboard.vehicle_model
              "
              :data="data[indextr].vehicle_model">
              <p class="product-name font-medium">{{ tr.vehicle_model }}</p>
            </vs-td>
            <vs-td
              class="py-2"
              :data="data[indextr].vehicle_number"
              v-if="
                isCommandCenter &&
                getRolePermission().dashboard.header_dashboard.vehicle_number
              ">
              <p>{{ tr.vehicle_number }}</p>
            </vs-td>
            <vs-td
              :data="data[indextr].imei"
              v-if="
                isCommandCenter &&
                getRolePermission().dashboard.header_dashboard.imei
              ">
              <p>{{ tr.imei }}</p>
            </vs-td>
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.driver"
              :data="data[indextr].driver_name">
              <p>{{ tr.driver_name }}</p>
            </vs-td>
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.driver"
              :data="data[indextr].driver_phone">
              <p>{{ tr.driver_phone }}</p>
            </vs-td>
            <vs-td
              v-if="
                type !== 'repair' &&
                getRolePermission().dashboard.header_dashboard.speed
              "
              :data="data[indextr].speed">
              <p>{{ tr.speed }} km/h</p>
            </vs-td>
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.last_update"
              :data="data[indextr].device_time">
              <p v-if="type == 'idle' || type == 'stop'">
                {{ formatDate(tr.activity_date) }} WIB
              </p>
              <p v-else>{{ formatDate(tr.device_time) }} WIB</p>
            </vs-td>
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.address"
              :data="data[indextr].address">
              <!--<p>{{tr.address}}</p>-->
              <a
                v-if="tr.address"
                :href="`https://www.google.com/maps/search/?api=1&query=${tr.latitude},${tr.longitude}`"
                target="_blank"
                rel="noopener noreferrer">
                <p>{{ tr.address }}</p>
              </a>
              <p v-else class="loader_1"></p>
            </vs-td>
            <vs-td
              v-if="getRolePermission().dashboard.header_dashboard.duration"
              :data="data[indextr].device_time">
              <p v-if="type == 'idle' || type == 'stop'">
                {{ getDurationV2(tr.activity_date) }}
              </p>
              <p v-else>{{ getDurationV2(tr.device_time) }}</p>
            </vs-td>
            <vs-td
              v-if="
                type == 'silent' &&
                getRolePermission().dashboard.header_dashboard.action
              ">
              <vs-button type="border" @click.stop="addToRepair(tr, true)"
                >+ Add to repair vehicle</vs-button
              >
            </vs-td>
            <vs-td
              v-if="
                type == 'repair' &&
                getRolePermission().dashboard.header_dashboard.action
              ">
              <vs-button
                type="border"
                color="danger"
                @click.stop="addToRepair(tr, false)"
                >+ remove from repair vehicle</vs-button
              >
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
            </div>
          </section>
          <footer class="modern-modal__footer">
            <vs-pagination :total="last_page" v-model="page"></vs-pagination>
          </footer>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import * as REPO from '../../repository/index'
import * as _ from 'lodash'

import Loading from 'vue-loading-overlay'
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css'
import { json2excel, excel2json } from 'js2excel'

export default {
  props: {
    addNewData: {
      type: Boolean,
      required: true,
    },
    title: String,
    fleetGroupId: String,
    isCommandCenter: Boolean,
    isAdministrator: Boolean,
    isCoordinator: Boolean,
    alertData: Array,
    fleetGroupData: Array,
    all_fleet: Array,
    editMode: Boolean,
    type: String,

    isLoading: false,
    dataEdit: Object,
  },
  components: {
    Loading,
  },
  watch: {
    addNewDataLocal(val) {
      if (val) {
        // Reset state when modal opens
        this.page = 1
        this.data = []
        this.last_page = 1

        // Cancel all active geocoding requests
        this.cancelAllGeocodeRequests()

        // Clear geocoding queue
        this.geocodingQueue = []

        // Fetch first page from backend
        this.fetchPageData(1)
      }
    },
    page(val) {
      // Fetch data for the new page from backend
      this.fetchPageData(val)
    },
    selected_filter(val) {
      //
      const self = this
      this.search = ''
      this.search_array = []
      if (val == 'license_plate') {
        setTimeout(() => {
          const inputs = document.getElementsByTagName('input')
          const input = Array.from(inputs).find(
            (x) => x['placeholder'] == 'Search License Plate'
          )
          //
          input.removeEventListener('keydown', self.onKeyDownLicense, true)
          input.addEventListener('keydown', self.onKeyDownLicense, true)
          input.addEventListener(
            'keyup',
            (e) => (e.target.value = e.target.value.toUpperCase()),
            true
          )
        }, 50)
      }
    },
    s_alert(val) {
      this.calculateFleet(val)
    },
  },
  mounted() {
    //
    this.filter_array = [
      {
        text: 'License Plate',
        value: 'license_plate',
      },
      {
        text: 'IMEI',
        value: 'imei_obd_number',
      },
      {
        text: 'Fleet Group',
        value: 'fleet_group_id',
      },
    ]
  },
  computed: {
    addNewDataLocal: {
      get() {
        this.page = 1
        this.clearFields()

        return JSON.parse(this.addNewData)
      },
      set(val) {
        if (!val) {
          //
          this.$emit('closeModal')
        }
      },
    },
    repoName() {
      function capiltalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      }

      // Special case for geofence type
      if (this.type === 'geofence') {
        return 'getDashboardGeofenceViolation'
      }

      const t = `getDashboard${capiltalize(this.type)}Vehicle`

      return t
    },
    validateForm() {
      return !this.errors.any() && this.mailTo != ''
    },
    modalSubtitle() {
      const subtitleMap = {
        total:
          'Review the complete list of vehicles along with their latest activity.',
        moving:
          'Monitor vehicles that are currently moving, including speed and driver details.',
        idle:
          'Inspect vehicles that are idle and track how long they have been stationary.',
        stop:
          'See vehicles that are stopped and review their recent locations.',
        silent:
          'Identify silent vehicles and decide whether to move them into repair.',
        repair:
          'Validate vehicles currently in repair and manage their status updates.',
      }

      return subtitleMap[this.type] || 'Inspect detailed vehicle information for this status.'
    },
  },
  data() {
    return {
      alert_array: [],
      fleet_array: [],
      data: [],
      filter_array: [],
      listPaired: [],
      search_array: [],
      s_alert: '',
      searchA: '',
      search: '',
      selected_filter: '',
      currentPage: 1,
      last_page: 1,
      page: 1,
      itemsPerPage: 15,
      searchB: '',
      isFullscreen: true,
      fleetGroup: '',
      strips: [],
      geocodingCache: new Map(),
      activeGeocodeRequests: new Map(),
      geocodingQueue: [],
      isProcessingGeocode: false,
      localLoading: false,
    }
  },
  methods: {
    addToRepair(vehicle, isIn = false) {
      if (isIn) {
        this.$emit('manualRepair', vehicle)
      } else {
        this.$emit('removeRepair', vehicle)
      }
    },
    isManualVehicle(vehicle) {
      if (!vehicle) return false
      if (typeof vehicle.is_manual !== 'undefined' && this.isTruthyManualFlag(vehicle.is_manual)) {
        return true
      }
      if (typeof vehicle.isManual !== 'undefined' && this.isTruthyManualFlag(vehicle.isManual)) {
        return true
      }
      if (vehicle.manual_reason || vehicle.manual_attachment_url) {
        return true
      }
      return false
    },
    isTruthyManualFlag(value) {
      if (typeof value === 'boolean') return value
      if (typeof value === 'number') return value === 1
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase()
        return normalized === 'true' || normalized === '1' || normalized === 'yes'
      }
      return false
    },
    onKeyDownLicense(e) {
      this.automateLicensePlate(e, e.target, this.strips)
    },
    async getAddress(latitude, longitude) {
      const body = {
        lat: latitude,
        lon: longitude,
      }
      let tmp = await REPO.getAddress(body)
      //
      return tmp.data
    },
    getCacheKey(latitude, longitude) {
      return `${latitude},${longitude}`
    },
    cancelAllGeocodeRequests() {
      // Cancel all active requests
      this.activeGeocodeRequests.forEach((abortController) => {
        try {
          abortController.abort()
        } catch (err) {
          // Ignore abort errors
        }
      })
      this.activeGeocodeRequests.clear()
    },
    async fetchPageData(page = 1) {
      // Show loading
      this.localLoading = true

      try {
        // Build params based on filter
        let param = { page }

        if (this.selected_filter === 'license_plate') {
          param.license_plate = this.search
        } else if (this.selected_filter === 'imei_obd_number') {
          param.imei = this.search
        } else if (this.selected_filter === 'fleet_group_id') {
          param.fleet_group_id = this.search
        }

        // Fetch from backend
        const res = await REPO[this.repoName](this.fleetGroupId, param)

        if (res.data.status === 'true') {
          // Update pagination info
          this.last_page = res.data.data.last_page || 1

          // Set data (only 15 items from backend)
          this.data = res.data.data.data || []

          // Cancel previous geocoding
          this.cancelAllGeocodeRequests()

          // Geocode visible items
          this.$nextTick(() => {
            this.geocodeVisibleItems()
          })
        } else {
          this.data = []
          this.last_page = 1
        }
      } catch (error) {
        console.error('Error fetching page data:', error)
        this.data = []
        this.last_page = 1

        // Show error to user
        this.$vs.notify({
          title: 'Error',
          text: 'Failed to load vehicle data',
          color: 'danger',
          position: 'bottom-right',
        })
      } finally {
        this.localLoading = false
      }
    },
    async geocodeVisibleItems() {
      // Data is already paginated from backend (only 15 items)
      // Just geocode all items in this.data
      const visibleItems = this.data

      // Process visible items with concurrency limit
      const concurrencyLimit = 3 // Only 3 requests at a time
      const chunks = []
      for (let i = 0; i < visibleItems.length; i += concurrencyLimit) {
        chunks.push(visibleItems.slice(i, i + concurrencyLimit))
      }

      for (const chunk of chunks) {
        await Promise.all(
          chunk.map(async (item) => {
            const index = this.data.findIndex(
              (x) => x.license_plate === item.license_plate
            )
            if (index === -1) return

            // Skip if already has address
            if (this.data[index].address) return

            const cacheKey = this.getCacheKey(item.latitude, item.longitude)

            // Check cache first
            if (this.geocodingCache.has(cacheKey)) {
              this.$set(this.data, index, {
                ...this.data[index],
                address: this.geocodingCache.get(cacheKey),
              })
              return
            }

            // Skip if no coordinates
            if (!item.latitude || !item.longitude) {
              this.$set(this.data, index, {
                ...this.data[index],
                address: '',
              })
              return
            }

            // Geocode with error handling
            try {
              const tmp = await this.getAddress(item.latitude, item.longitude)
              const address = tmp.display_name || ''

              // Cache the result
              this.geocodingCache.set(cacheKey, address)

              // Update data
              this.$set(this.data, index, {
                ...this.data[index],
                address: address,
              })
            } catch (err) {
              console.error('Geocoding error:', err)
              this.$set(this.data, index, {
                ...this.data[index],
                address: '',
              })
            }
          })
        )
      }
    },
    downloadData() {
      try {
        this.localLoading = true
        let t = this.type
        if (this.type == 'silent') {
          t = 'silence'
        }

        const fleet_id =
          this.selected_filter == 'fleet_group_id'
            ? this.search
            : this.fleetGroupId

        //

        REPO.getAllVehicleDownload(t, fleet_id)
          .then((res) => {
            const data = Array.isArray(res.data.data) ? res.data.data : []
            this.localLoading = false

            const exportData = data.map((item) => ({
              license_plate: item.license_plate || '',
              device_time: item.device_time || '',
              duration: item.device_time
                ? this.getDuration(item.device_time)
                : '',
              vehicle_activity: item.vehicle_activity || '',
              speed: item.speed || 0,
              latitude: item.latitude || '',
              longitude: item.longitude || '',
              driver_name: item.driver_name || '',
              fleet_group_name: item.fleet_group_name || '',
              vehicle_model: item.vehicle_model || '',
              imei: item.imei || '',
              'Sim Card Number':
                item.simcard_number || item.sim_card_number || '',
            }))

            json2excel({
              data: exportData,
              name: this.title,
              formateDate: 'yyyy-mm-dd hh:ss',
            })
          })
          .catch((err) => {
            alert(err)
            this.localLoading = false
          })
        // setTimeout(() => {
        //
        // },5000)
      } catch (e) {
        this.localLoading = false
        alert(e)
        console.error('export error')
      }
    },
    loadingStart(val) {
      //
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
    onSearch(search, loading) {
      loading(true)
      this.searchProcess(loading, search, this)
    },
    searchProcess: _.debounce((loading, search, vm) => {
      let params
      // upppercase variable
      const t = vm.type.toUpperCase()
      if (vm.selected_filter == 'license_plate') {
        params = {
          type: t,
          license_plate: search,
        }
      }
      if (vm.selected_filter == 'imei_obd_number') {
        params = {
          type: t,
          imei: search,
        }
      }
      if (vm.selected_filter == 'fleet_group_id') {
        params = {
          type: t,
          fleet_group_name: search,
        }
      }
      //

      REPO.getAutocomplete(vm.fleetGroupId, params).then((res) => {
        let tmp = res.data.data
        let hasil = []
        vm.search_array = []
        tmp.forEach((x) => {
          if (vm.selected_filter == 'license_plate') {
            hasil.push({
              text: x.license_plate,
              value: x.license_plate,
            })
          } else if (vm.selected_filter == 'imei_obd_number') {
            hasil.push({
              text: x.imei,
              value: x.imei,
            })
          } else if (vm.selected_filter == 'fleet_group_id') {
            hasil.push({
              text: x.fleet_group_name,
              value: x.fleet_group_id,
            })
          }
        })
        vm.search_array = hasil
        loading(false)
      })
    }, 350),
    handleSelected(tr) {
      this.closeForm()
      setTimeout(() => {
        this.$router.push('/monitoring-vehicle/' + tr.vehicle_id)
      }, 300)
    },
    filterData(pg = 1) {
      // Reset to page 1 when filtering
      this.page = pg
      // Use fetchPageData to get filtered results
      this.fetchPageData(pg)
    },
    // getDuration(val) {
    //   let x = new Date(val)
    //   let now = new Date()
    //   var timeDiff = now - x
    //   timeDiff /= 1000

    //   var seconds = Math.round(timeDiff)
    //   timeDiff = Math.floor(timeDiff / 60)

    //   var minutes = Math.round(timeDiff % 60)
    //   timeDiff = Math.floor(timeDiff / 60)

    //   var hours = Math.round(timeDiff % 24)
    //   timeDiff = Math.floor(timeDiff / 24)

    //   var days = Math.round(timeDiff % 365)
    //   timeDiff = Math.floor(timeDiff / 365)

    //   var years = timeDiff

    //   if (years > 0) {
    //     return years + (years > 1 ? ' Years ' : ' Year ') + 'ago'
    //   } else if (days > 0) {
    //     return days + (days > 1 ? ' Days ' : ' Day ') + 'ago'
    //   } else if (hours > 0) {
    //     return hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago'
    //   } else if (minutes > 0) {
    //     return minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago'
    //   } else if (seconds > 0) {
    //     return seconds + (seconds > 1 ? `sec ago` : 'just now')
    //   }

    //   return 'Just Now'
    // },
    formatDate(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    },
    closeForm() {
      this.clearFields()

      setTimeout(() => {
        this.$emit('closeModal', false)
      }, 100)
    },
    clearFields() {
      this.selected_filter = ''
      this.search = ''
      this.listPaired = []
      this.fleetGroup = ''
      // if (this.isCommandCenter) {
      this.filter_array = [
        {
          text: '-- All --',
          value: 'all',
        },
        {
          text: 'License Plate',
          value: 'license_plate',
        },
        {
          text: 'IMEI',
          value: 'imei_obd_number',
        },
        {
          text: 'Fleet Group',
          value: 'fleet_group_id',
        },
      ]
      // } else {
      //   this.filter_array = [
      //     {
      //       text: '-- All --',
      //       value: 'all',
      //     },
      //     {
      //       text: 'License Plate',
      //       value: 'license_plate',
      //     },
      //   ]
      // }
    },
    loadingBtnStart(val) {
      this.$vs.loading({
        container: `.${val}`,
        scale: 0.45,
      })
    },
    loadingBtnStop(val) {
      this.$vs.loading.close(`.${val} > .con-vs-loading`)
    },
  },
}
</script>
<style>
#content-area.content-area-default
  .header-card-modal-root
  .modern-modal__overlay {
  left: 260px;
}

#content-area.content-area-reduced
  .header-card-modal-root
  .modern-modal__overlay {
  left: 80px;
}

#content-area.content-area-full .header-card-modal-root .modern-modal__overlay,
#content-area:not(.content-area-default):not(.content-area-reduced)
  .header-card-modal-root
  .modern-modal__overlay {
  left: 0;
}

@media (max-width: 768px) {
  #content-area .header-card-modal-root .modern-modal__overlay {
    left: 0 !important;
    right: 0;
  }
}
</style>
<style scoped>
.manual-bookmark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 9999px;
  font-size: 11px;
  background-color: #fef3c7;
  color: #b45309;
  border: 1px solid rgba(180, 83, 9, 0.25);
}

.manual-bookmark ::v-deep svg {
  stroke: currentColor;
}

.manual-bookmark__text {
  line-height: 1;
}

.header-card-modal-root {
  display: contents;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.98);
}

.modern-modal__overlay {
  position: fixed;
  top: 64px;
  left: 260px;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  z-index: 2147483647;
  overflow-y: auto;
}

.modern-modal {
  width: min(1100px, 96vw);
  max-height: 88vh;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 28px 70px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modern-modal--xl {
  width: min(1160px, 97vw);
}

.modern-modal__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 24px 32px 16px;
  border-bottom: 1px solid #e2e8f0;
  gap: 16px;
}

.modern-modal__header-text {
  flex: 1 1 auto;
  min-width: 0;
}

.modern-modal__title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 600;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.modern-modal__subtitle {
  margin: 6px 0 0;
  font-size: 0.9rem;
  line-height: 1.45;
  color: #64748b;
  max-width: 620px;
}

.modern-modal__close {
  background: transparent;
  border: none;
  border-radius: 9999px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease;
}

.modern-modal__close:hover {
  background: rgba(148, 163, 184, 0.25);
}

.modern-modal__body {
  padding: 20px 28px 8px;
  overflow: hidden;
}

.modern-modal__table {
  margin: 0;
  background: transparent;
}

.modern-modal__scroll {
  max-height: calc(88vh - 200px);
  overflow-y: auto;
  padding-right: 6px;
}

.modern-modal__scroll::-webkit-scrollbar {
  width: 6px;
}

.modern-modal__scroll::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.6);
  border-radius: 9999px;
}

.modern-modal__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.modern-modal__table-toolbar {
  margin-bottom: 12px;
}

.modern-modal__filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.modern-modal__search-select {
  width: 200px;
}

.modern-modal__filter-btn {
  padding: 10px 18px !important;
}

.modern-modal__download-btn {
  min-width: 200px;
  padding: 10px 18px !important;
}

.modern-modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 18px 32px 28px;
  border-top: 1px solid #e2e8f0;
}

.modern-modal__footer ::v-deep(.vs-pagination--ul) {
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .modern-modal {
    max-height: 92vh;
    border-radius: 16px;
  }

  .modern-modal__body {
    padding: 16px 18px 4px;
  }

  .modern-modal__footer {
    padding: 16px 20px 24px;
  }

  .modern-modal__download-btn {
    width: 100%;
    margin-top: 12px;
  }

  .modern-modal__table-toolbar {
    gap: 12px;
  }

  .modern-modal__filters {
    flex-direction: column;
    align-items: stretch;
  }

  .modern-modal__search-select {
    width: 100%;
  }
}
</style>
